import swal from "sweetalert";
import router from "@/router";

export function errorMessage() {
  swal({
    title: "There is something wrong",
    text: "Please, try again.",
    icon: "error",
    dangerMode: true
  });
}

export function missingFieldsAlert(text) {
  swal({
    title: "Missing fields",
    text: `${text}`,
    icon: "warning",
    button: "OK"
  });
}

export function errorAlert(title, text) {
  swal({
    title: `${title}`,
    text: text,
    icon: "error",
    button: "OK",
    dangerMode: true
  });
}

export function tokenExpired() {
  swal({
    title: "The token has expired",
    text: "Please, login again",
    icon: "warning",
    button: "Ok",
    dangerMode: true
  }).then(willDelete => {
    localStorage.removeItem("charlie-username-otr");
    localStorage.removeItem("charlie-otr-token");
    localStorage.removeItem("charlie-user-department");
    localStorage.removeItem("current-department");
    localStorage.removeItem("actual-queue");
    router.push({
      name: "Login"
    });
    return willDelete;
  });
}

export async function warningMessage(text) {
  return swal({
    title: "Are you sure?",
    text: `${text}`,
    icon: "warning",
    buttons: true,
    dangerMode: true
  }).then(willDelete => {
    if (willDelete) {
      return true;
    } else {
      return false;
    }
  });
}

export async function warningMessageWithoutConfimation(text) {
  return swal({
    title: "Please Wait!",
    text: `${text}`,
    icon: "warning",
    button: "OK"
  });
}
